/** WebSocket URL for `/ws/notifications`. An empty base stays on the page origin. */
export const notificationWebSocketUrl = (pageUrl: string, serviceBaseUrl: string): string => {
  if (serviceBaseUrl) {
    const base = new URL(serviceBaseUrl);
    const protocol = base.protocol === "https:" ? "wss:" : "ws:";

    return `${protocol}//${base.host}/ws/notifications`;
  }

  const page = new URL(pageUrl);
  const protocol = page.protocol === "https:" ? "wss:" : "ws:";

  return `${protocol}//${page.host}/ws/notifications`;
};
